import { createContext, useContext, type ReactNode } from 'react'
import type { DestinationViewerSession, JsonValue } from '../types'

const ViewerSessionContext = createContext<DestinationViewerSession | null>(null)

export function ViewerSessionProvider({
  session,
  children,
}: {
  session: DestinationViewerSession
  children: ReactNode
}) {
  return (
    <ViewerSessionContext.Provider value={session}>
      {children}
    </ViewerSessionContext.Provider>
  )
}

export function useViewerSession(): DestinationViewerSession {
  const context = useContext(ViewerSessionContext)
  if (!context) throw new Error('useViewerSession must be used inside <ViewerSessionProvider>.')
  return context
}

export function useViewerCapability(capability: string): boolean {
  return useViewerSession().capabilities.includes(capability)
}

export function useViewerPreference<T extends JsonValue = JsonValue>(
  key: string,
): T | null {
  return (useViewerSession().preferences[key] as T | undefined) ?? null
}
